import ToggleTheme from 'components/theme/Header/ToggleTheme';
import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Wrapper } from './styles';

const NavbarLinks = ({ desktop }) => (
  <Wrapper desktop={desktop}>
    <AnchorLink href="#about">About</AnchorLink>
    <AnchorLink href="#works">Works</AnchorLink>
    <AnchorLink href="#medium">Blogs</AnchorLink>
    <AnchorLink href="#contact">Contact</AnchorLink>

    <a href="https://anyesh.netlify.com/" target="__blank">
      Resume
    </a>
    <ToggleTheme />
  </Wrapper>
);

export default NavbarLinks;
